
function translateOutcome(outcome) {
  if (outcome === 'Won') {
    return 1;
  } 
  if (outcome === 'Lost') {
    return 2;
  } 
  if (outcome === 'No Decision') {
    return 3;
  }
  return 4;
}

function translateDealType(dealtype) {
  if (dealtype === 'New business') {
    return 1;
  }
  if (dealtype === 'Add-on') {
    return 2;
  } 
  if (dealtype === 'Upsell') {
    return 3;
  } 
  if (dealtype === 'Renewal') {
    return 4;
  }
  return 0;
}

function reverseTranslateOutcome(outcome) {
  if (outcome === 1) {
    return 'Won';
  } 
  if (outcome === 2) {
    return 'Lost';
  } 
  if (outcome === 3) {
    return 'No Decision';
  }
  return 'Other';
}

function translateOpportunity(opportunity) {
  const validOpportunity = {
    sfa__opportunityId: opportunity.opportunity_id,
    sfa__opportunityName: opportunity.name,
    sfa__opportunityCloseDate: opportunity.close_date,
    sfa__opportunityCreatedDate: opportunity.created_date,
    sfa__accountId: opportunity.account_id,
    sfa__ownerId: opportunity.owner_id,
    outcome: translateOutcome(opportunity.outcome || opportunity.stage),

    opportunityValue: opportunity.amount,
    salesQuestion: opportunity.question,
    additionalInformation: opportunity.additional_information,

    sfa__accountName: opportunity.account ? opportunity.account.name : null,
    sfa__accountNumber: opportunity.account ? opportunity.account_id : null,
    sfa__accountPhone: opportunity.account ? opportunity.account.phone : null,
    annualRevenue: opportunity.account ? opportunity.account.annual_revenue : null,
    webSite: opportunity.account ? opportunity.account.website : null,
    industry: opportunity.account ? opportunity.account.industry : null,
    employeesCount: opportunity.account ? opportunity.account.number_of_employees : null,

    sfa__ownerFirstName: opportunity.owner ? opportunity.owner.first_name : null,
    sfa__ownerLastName: opportunity.owner ? opportunity.owner.last_name : null,
    sfa__ownerEmail: opportunity.owner ? opportunity.owner.email : null,

    tv__productIds: opportunity.tv__productIds, // from FE when submitted translated to TV product ids
  };
  return validOpportunity;
}


function translateNominationOpportunities(clientId, initiativeId, typeValue, opportunities) {
  const validOpportunities = [];
  (opportunities || []).forEach((opportunity) => {
    const validContacts = [];
    (opportunity.selected_contacts || []).forEach((contact) => {
      const ma = contact.mailing_address || {};
      const validContact = {
        sfa__contactId: contact.contact_id,
        sfa__accountId: contact.account_id,
        sfa__description: contact.description,
        firstName: contact.first_name,
        lastName: contact.last_name,
        priority: contact.priority,
        title: contact.title,
        email: contact.email,
        phone: contact.phone,
        phoneExtension: contact.phone_extension,
        mobilePhone: contact.mobile_phone,
        buyerRole: contact.buyer_role, // truvoice value, from FE
        buyerType: contact.buyer_type, // truvoice value, from FE
        tags: contact.tags || [], // truvoice value, from FE
        notes: contact.notes || '',
        sfa__isPrimaryContact: contact.is_primary, // translated from FE
        sfa__role: contact.role, // translated from FE
        mailingCountry: ma.country,
        mailingCity: ma.city,
        mailingState: ma.state,
        mailingPostalCode: ma.postal_code,
        mailingAddress: ma.street,
      };
      validContacts.push(validContact);
    });

    if (validContacts.length > 0) {
      const validOpportunity = translateOpportunity(opportunity);

      validOpportunity.tv__clientId = clientId;
      validOpportunity.tv__initiativeId = initiativeId;
      validOpportunity.researchType = 1; // (1=Decision, 2=Experience, 3=Research), https://github.com/lumen-software/TruSales/issues/1026

      validOpportunity.tv__productId = opportunity.tv__productIds && opportunity.tv__productIds.length > 0 ? opportunity.tv__productIds[0] : null;
      validOpportunity.product = opportunity.product; // from FE when submitted
      validOpportunity.contacts = validContacts;
      validOpportunities.push(validOpportunity);
    }
  });

  const params = {
    program_type: typeValue,
    opportunities: validOpportunities,
  };

  return params;
}

function translateNominationAccounts(clientId, initiativeId, typeValue, accounts) {
  const validAccounts = [];

  (accounts || []).forEach((account) => {
    const validContacts = [];
    (account.selected_contacts || []).forEach((contact) => {
      const ma = contact.mailing_address || {};
      const validContact = {
        sfa__contactId: contact.contact_id,
        sfa__accountId: contact.account_id,
        sfa__description: contact.description,
        firstName: contact.first_name,
        lastName: contact.last_name,
        priority: contact.priority,
        title: contact.title,
        email: contact.email,
        phone: contact.phone,
        phoneExtension: contact.phone_extension,
        mobilePhone: contact.mobile_phone,
        buyerRole: contact.buyer_role, // truvoice value, from FE
        buyerType: contact.buyer_type, // truvoice value, from FE
        tags: contact.tags || [], // truvoice value, from FE
        notes: contact.notes || '',

        sfa__isPrimaryContact: contact.is_primary, // translated from FE
        sfa__role: contact.role, // translated from FE

        mailingCountry: ma.country,
        mailingCity: ma.city,
        mailingState: ma.state,
        mailingPostalCode: ma.postal_code,
        mailingAddress: ma.street,
      };
      validContacts.push(validContact);
    });

    if (validContacts.length > 0) {
      const billingAddress = account.account ? account.account.billing_address || {} : {};
      const validAccount = {
        tv__clientId: clientId,
        tv__initiativeId: initiativeId,
        researchType: 2, // (1=Decision, 2=Experience, 3=Research), https://github.com/lumen-software/TruSales/issues/1026

        sfa__opportunityId: account.opportunity_id,
        sfa__opportunityName: account.name,

        sfa__opportunityCloseDate: new Date(),
        sfa__opportunityCreatedDate: account.created_date,
        sfa__accountId: account.account_id,
        sfa__ownerId: account.owner_id,
        outcome: translateOutcome(),

        opportunityValue: account.amount,
        salesQuestion: account.question,
        additionalInformation: account.additional_information,

        sfa__accountType: account.account ? account.account.type : null,
        sfa__accountName: account.account ? account.account.name : null,
        sfa__accountNumber: account.account ? account.account_id : null,
        sfa__accountPhone: account.account ? account.account.phone : null,

        sfa__billingCity: billingAddress.city,
        sfa__billingCountry: billingAddress.country,
        sfa__billingCountryCode: billingAddress.country_code,
        sfa__billingPostalCode: billingAddress.postal_code,
        sfa__billingState: billingAddress.state,
        sfa__billingStateCode: billingAddress.state_code,
        sfa__billingAddress: billingAddress.street,

        annualRevenue: account.account ? account.account.annual_revenue : null,
        webSite: account.account ? account.account.website : null,
        industry: account.account ? account.account.industry : null,
        employeesCount: account.account ? account.account.number_of_employees : null,

        sfa__ownerFirstName: account.owner ? account.owner.first_name : null,
        sfa__ownerLastName: account.owner ? account.owner.last_name : null,
        sfa__ownerEmail: account.owner ? account.owner.email : null,

        tv__productIds: account.tv__productIds, // from FE when submitted translated to TV product ids
        tv__productId: account.tv__productIds && account.tv__productIds.length > 0 ? account.tv__productIds[0] : null,
        product: account.product, // from FE when submitted
        contacts: validContacts,
      };
      validAccounts.push(validAccount);
    }
  });

  const params = {
    program_type: typeValue,
    opportunities: validAccounts,
  };
  return params;
}



function convertTSFieldTypeToTVFieldTypeNum(type) {
  // https://github.com/lumen-software/TruSales/issues/1451
  /*
  +==========+==============+
  | dataType | dataName     |
  +==========+==============+     
  | 2        | Text         |
  +----------+--------------+
  | 8        | Boolean      |
  +----------+--------------+
  | 9        | Date         |
  +----------+--------------+
  | 16       | Number       |
  +----------+--------------+
  | 20       | SingleSelect |
  +----------+--------------+
  | 21       | MultiSelect  |
  +----------+--------------+
  */
  const TYPES = {
    currency: [16, 22], // Number, Currency
    int: [16],
    double: [16],
    percent: [16],
    number: [16],
    boolean: [8],
    combobox: [8],
    picklist: [20, 21], // https://github.com/lumen-software/TruSales/issues/1927
    multipicklist: [21, 20], // https://github.com/lumen-software/TruSales/issues/1927
    date: [9],
    email: [23], // https://github.com/lumen-software/TruSales/issues/1864
    // otherwise: string,
  };
  return TYPES[type] || [2, 23];
}

module.exports = {
  translateOutcome,
  translateNominationOpportunities,
  translateNominationAccounts,
  reverseTranslateOutcome,
  translateOpportunity,
  translateDealType,
  convertTSFieldTypeToTVFieldTypeNum,
};
